// Default checklist tasks
// Organized by time before the wedding

export const defaultTasks = [
  // You're Engaged!
  {
    description: "Tell the people who matter (and maybe Instagram too).",
    tip_from_collective: "Start with family and close friends before it hits social media — trust us, your grandma doesn't want to find out from a hashtag.",
    time_before: "12 months before"
  },
  {
    description: "Set a budget — and check if family is chipping in",
    tip_from_collective: "Be realistic here: everything else flows from this. If parents are helping, ask early so there are no surprises later. Money saving tip: decide your \"non-negotiables\" before you start browsing — it keeps you from overspending on shiny extras.",
    time_before: "12 months before"
  },
  {
    description: "List each of you list top priorities",
    tip_from_collective: "Maybe it's food, music, or photography. Knowing what matters most makes decisions (and compromises) much easier down the line (hint: it's not the napkins).",
    time_before: "12 months before"
  },
  {
    description: "Talk about the overall feel: epic party? chill dinner? mountains?",
    tip_from_collective: "Think experience, not just \"theme.\" Are you imagining guests barefoot on a beach, or tearing up a dance floor at 2 am? This vision keeps you anchored when details start spiraling.",
    time_before: "12 months before"
  },
  {
    description: "Draft a guest list in Guest Manager (yes, even the \"maybe\" cousins).",
    tip_from_collective: "Guest count = budget reality check. Start wide, then trim. And remember: every +1 is another meal, chair, and invite.",
    time_before: "12 months before"
  },
  {
    description: "Lock in rough dates and a location vibe.",
    tip_from_collective: "Venues book up fast. Even a general season or month will help you filter vendors and manage expectations. Wedding survival tip: If you're eyeing a peak date, book the venue first and everything else falls into place.",
    time_before: "12 months before"
  },
  {
    description: "Decide how to slice the pie — venue, food, outfits, the works.",
    tip_from_collective: "Most couples spend 40–50% of their budget on venue + catering. The rest disappears fast into what we call the \"hidden costs\": vendors (photographer, music, celebrant), outfits, invites, décor, flowers, transport, even tips and insurance. A shared spreadsheet (or our tool) keeps everything in sight so nothing sneaks up on you.",
    time_before: "12 months before"
  },
  {
    description: "Start saving inspo: colors, florals, outfits, random champagne towers.",
    tip_from_collective: "It's easy to get overwhelmed. Keep one private board where you pin freely, then a smaller \"shortlist\" board for ideas you actually want to explore",
    time_before: "12 months before"
  },

  // 12+ Months Before
  {
    description: "Guest list reality check",
    tip_from_collective: "Your venue + catering hang on this number. Be decisive now — \"just 10 more\" later = $$$.",
    time_before: "12 months before"
  },
  {
    description: "Venue hunt begins",
    tip_from_collective: "Shortlist spots that fit your budget, guest count, and vibe. Money saving tip: venues that include basics (tables, chairs, lighting) save you big.",
    time_before: "12 months before"
  },
  {
    description: "Go see them IRL. Only top 3-5 venues.",
    tip_from_collective: "A walkthrough tells you if the vibe's right — and if there are enough bathrooms.",
    time_before: "12 months before"
  },
  {
    description: "Lock in venue + date",
    tip_from_collective: "Once this is booked, the rest clicks into place. Don't wait too long: peak dates disappear fast.",
    time_before: "12 months before"
  },
  {
    description: "Start dress shopping",
    tip_from_collective: "Many gowns take 10+ months. Start early so you're choosing \"love\" not \"last-minute panic.\"",
    time_before: "12 months before"
  },
  {
    description: "Find your photographer",
    tip_from_collective: "They'll be glued to you all day. Choose someone whose style you love and whose presence you won't mind in your face for 10 hours.",
    time_before: "12 months before"
  },

  // 10 months before
  {
    description: "Book a hotel block",
    tip_from_collective: "Great for destination weddings. Guests get discounts, you get fewer \"where should we stay?\" texts.",
    time_before: "10 months before"
  },
  {
    description: "Secure your caterer",
    tip_from_collective: "Tastings are non-negotiable. Confirm if staff, rentals, and cake cutting are included. Survival tip: clarify what \"per person\" actually means.",
    time_before: "10 months before"
  },
  {
    description: "Find your officiant",
    tip_from_collective: "Ceremony tone = officiant style. Book early, especially if you need them legally registered.",
    time_before: "10 months before"
  },
  {
    description: "Book your entertainment",
    tip_from_collective: "DJ, band, or both. Ask about set-up needs and breaks — no one wants dead air on the dance floor.",
    time_before: "10 months before"
  },
  {
    description: "Book a Wedding Planner",
    tip_from_collective: null,
    time_before: "10 months before"
  },

  // 9 Months Before
  {
    description: "Send Save the Dates",
    tip_from_collective: "Mail or digital, just get them out 8-10 months ahead (more if it's destination).",
    time_before: "9 months before"
  },
  {
    description: "Wedding Party attire shopping",
    tip_from_collective: "Get the crew fitted. Order early, alterations take time.",
    time_before: "9 months before"
  },
  {
    description: "Extra vendors check",
    tip_from_collective: "Photobooth, day-of coordinator, live painter. Add what fits your budget + vibe, skip the rest.",
    time_before: "9 months before"
  },
  {
    description: "Plan your honeymoon",
    tip_from_collective: "Pick location, book flights + hotel. Survival tip: schedule it a few days after the wedding to recover before you fly.",
    time_before: "9 months before"
  },
  {
    description: "Request time off work",
    tip_from_collective: "Do it early — your boss will thank you. Plus, no one wants Slack notifications on their wedding week.",
    time_before: "9 months before"
  },
  {
    description: "Book florist",
    tip_from_collective: null,
    time_before: "9 months before"
  },

  // 8 months before
  {
    description: "Rental roll call",
    tip_from_collective: "Guest count decides it all — tables, chairs, glassware, linens. Don't forget extras for vendors (yes, your band eats too).",
    time_before: "8 months before"
  },
  {
    description: "Wedding Party outfits",
    tip_from_collective: "Consistency is key, but comfort matters — no one loves blistered feet",
    time_before: "8 months before"
  },
  {
    description: "Groom's look",
    tip_from_collective: "Pro tip: schedule tailoring early, because last-minute suit panic is real.",
    time_before: "8 months before"
  },
  {
    description: "Bride's finishing touches",
    tip_from_collective: "Shoes, veil, jewelry, hairpieces. Break in the shoes before the big day — champagne + new heels = disaster.",
    time_before: "8 months before"
  },
  {
    description: "Secure transportation",
    tip_from_collective: "Limos, shuttles, vans. Whatever fits your guest count and vibe. Pro tip: confirm start + end times so no one's stranded at midnight.",
    time_before: "8 months before"
  },
  {
    description: "Book hair and makeup artist",
    tip_from_collective: null,
    time_before: "8 months before"
  },
  {
    description: "Order rental furniture/deco",
    tip_from_collective: null,
    time_before: "8 months before"
  },

  // 6 months before
  {
    description: "Book your rentals",
    tip_from_collective: "Lock in the basics: linens, plates, flatware, glassware. Money saving tip: rental packages often beat piecemeal orders.",
    time_before: "6 months before"
  },
  {
    description: "Groom's finishing touches",
    tip_from_collective: "Shoes, cufflinks, tie, pocket square. Tiny details, but they show up in every close-up photo.",
    time_before: "6 months before"
  },
  {
    description: "Cake time",
    tip_from_collective: "Research + book your baker. Tastings are half the fun. Confirm delivery, setup, and if cutting is included (yes, some charge).",
    time_before: "6 months before"
  },
  {
    description: "Do an engagement shoot",
    tip_from_collective: "A trial run that gives you keepsakes (and nice pics for invites or grandma's fridge).",
    time_before: "6 months before"
  },
  {
    description: "Buy wedding rings",
    tip_from_collective: null,
    time_before: "6 months before"
  },

  // 5 months before
  {
    description: "Invites on the way",
    tip_from_collective: "Design + order invitations. If DIY, allow extra time — printers move slower than you think. Send tehm when ready, gives guests time to plan (and book flights).",
    time_before: "5 months before"
  },
  {
    description: "Event wardrobe planning",
    tip_from_collective: "Rehearsal dinner, bridal shower, welcome drinks. Shop early so it's intentional, not \"last clean dress in the closet.\"",
    time_before: "5 months before"
  },
  {
    description: "Rehearsal dinner spot",
    tip_from_collective: "Research venues or restaurants, book if possible. Think intimate and relaxed — it sets the tone.",
    time_before: "5 months before"
  },
  {
    description: "Marriage license homework",
    tip_from_collective: "Research your state's rules. Timing matters — some expire quickly, others require a waiting period.",
    time_before: "5 months before"
  },
  {
    description: "Hire transportation (if applicable)",
    tip_from_collective: null,
    time_before: "5 months before"
  },

  // 3-4 months before
  {
    description: "Little details matter",
    tip_from_collective: "Vow book, guest book, frames, signage. Order early so they don't end up as Amazon Prime panic buys.",
    time_before: "3 months before"
  },
  {
    description: "Wedding Party accessories",
    tip_from_collective: "Bow ties, socks, jewelry, shawls. Coordinated looks = polished photos.",
    time_before: "3 months before"
  },
  {
    description: "Dress check-ins",
    tip_from_collective: "Confirm arrival, schedule fittings. Leave wiggle room for final alterations (your future self will thank you).",
    time_before: "3 months before"
  },
  {
    description: "Decor + favors locked",
    tip_from_collective: "Finalize purchases now so you're not hot-gluing centerpieces at midnight.",
    time_before: "3 months before"
  },
  {
    description: "Honeymoon plan",
    tip_from_collective: "Nail down itinerary and bookings. Double-check passport + visa requirements before you hit \"purchase.\"",
    time_before: "3 months before"
  },
  {
    description: "Ceremony music",
    tip_from_collective: "Musicians, DJs, or playlists. Think processional, signing, and exit — silence is awkward.",
    time_before: "3 months before"
  },
  {
    description: "Timeline draft",
    tip_from_collective: "Use the Timeline Creator to sketch your day. Build in buffer time (hair always runs long).",
    time_before: "3 months before"
  },
  {
    description: "Weekend game plan",
    tip_from_collective: "Map out rehearsal dinner, welcome drinks, and next-day brunch. Keeps guests busy, you less stressed.",
    time_before: "3 months before"
  },
  {
    description: "Marriage license appointment",
    tip_from_collective: "Book early. Some states require waiting periods or have short validity windows.",
    time_before: "3 months before"
  },
  {
    description: "Have food tasting with caterer",
    tip_from_collective: null,
    time_before: "3 months before"
  },

  // 2 months before
  {
    description: "Weekend timeline check",
    tip_from_collective: "Finalize rehearsal, ceremony, reception, brunch. Make sure vendors + venues are booked and times actually work.",
    time_before: "2 months before"
  },
  {
    description: "Finalize rehearsal, ceremony, reception, brunch. Make sure vendors + venues are booked and times actually work.",
    tip_from_collective: "Confirm details with your officiant — readings, vows, length. No surprises on the day.",
    time_before: "2 months before"
  },
  {
    description: "Soundtrack to your day",
    tip_from_collective: "Pick songs for processional, recessional, first dance, parent dances, last song. Share with your DJ/band.",
    time_before: "2 months before"
  },
  {
    description: "Order final stationery",
    tip_from_collective: "Table numbers, welcome sign, ceremony programs. Order once the timeline + guest list are set.",
    time_before: "2 months before"
  },
  {
    description: "Pre-wedding glow up",
    tip_from_collective: "Lashes, tan, nails, hair. Book close to the date, but not so close that there's no fix if something goes wrong.",
    time_before: "2 months before"
  },

  // 60-90 days before
  {
    description: "Start RSVPs",
    tip_from_collective: "Track responses in the Guest Manager. Send gentle nudges — people forget (yes, even close friends).",
    time_before: "3 weeks before"
  },
  {
    description: "Get your marriage license",
    tip_from_collective: null,
    time_before: "3 weeks before"
  },
  {
    description: "Final vendor check-ins",
    tip_from_collective: "Schedule last meetings + make final payments. Clear communication now = less stress later.",
    time_before: "3 weeks before"
  },
  {
    description: "Hand over your playlist",
    tip_from_collective: "Use the Music Planner to send your DJ song picks (first dance, parent dances, must-plays, do-not-plays).",
    time_before: "3 weeks before"
  },
  {
    description: "Photo game plan",
    tip_from_collective: "Discuss timing + shot list with your photographer. Family groupings take longer than you think — plan buffers.",
    time_before: "3 weeks before"
  },
  {
    description: "Menu locked",
    tip_from_collective: "Finalize meal choices + timing with your caterer. Confirm dietary requests have been captured.",
    time_before: "3 weeks before"
  },
  {
    description: "Flower power",
    tip_from_collective: "Confirm your floral order in the \"Lists templates\". Double-check delivery and setup times.",
    time_before: "3 weeks before"
  },
  {
    description: "Beauty timeline confirmed",
    tip_from_collective: "Lock hair + makeup schedule. Build in padding — glam always takes longer than planned.",
    time_before: "3 weeks before"
  },
  {
    description: "Table layout done",
    tip_from_collective: "Decide how the room flows: dance floor, head table, bars. It affects guest comfort (and the party vibe).",
    time_before: "3 weeks before"
  },
  {
    description: "Seating chart magic",
    tip_from_collective: "Assign tables in the Guest Manager. Mix personalities thoughtfully — your college roommate doesn't need to sit with your boss.",
    time_before: "3 weeks before"
  },
  {
    description: "Attire check",
    tip_from_collective: "Confirm the wedding party has all the pieces (shoes, accessories, alterations). No last-minute bow tie runs.",
    time_before: "3 weeks before"
  },

  // 30-60 Days Before
  {
    description: "Chase missing RSVPs",
    tip_from_collective: "Reach out to stragglers. Assume at least one guest will \"forget.\"",
    time_before: "1 month before"
  },
  {
    description: "Weather watch",
    tip_from_collective: "Start checking forecasts. Have a Plan B (tents, fans, heaters) so rain or heat doesn't wreck the vibe.",
    time_before: "1 month before"
  },
  {
    description: "Micrologistics + pack list",
    tip_from_collective: "Use the Packlist sheet for all the little things: chargers, signage, safety pins. Future you will be grateful.",
    time_before: "1 month before"
  },
  {
    description: "Timeline locked",
    tip_from_collective: "Finalize the Master Timeline. Share it with vendors + your wedding party so everyone's on the same page.",
    time_before: "1 month before"
  },
  {
    description: "Final outfit check",
    tip_from_collective: "Shoes, accessories, ties, jewelry. Try everything on together so no surprises on the day.",
    time_before: "1 month before"
  },
  {
    description: "Favors + gifts assembled",
    tip_from_collective: "Put them together early. Box, bag, label — done. Last-minute stuffing is stress you don't need.",
    time_before: "1 month before"
  },
  {
    description: "Draft your vows",
    tip_from_collective: "Start writing. Keep it real, keep it you. Practice reading them out loud — it hits differently.",
    time_before: "1 month before"
  },

  // 15-30 Days Before
  {
    description: "RSVP Reality Check",
    tip_from_collective: "Time to wrangle those last responses. Final guest count = locked in.",
    time_before: "2 weeks before"
  },
  {
    description: "Feed the Vendors (Info, Not Snacks)",
    tip_from_collective: "Send final guest counts, meal choices, and allergy notes their way.",
    time_before: "2 weeks before"
  },
  {
    description: "Seats & Sweet Spots",
    tip_from_collective: "Create and print your seating chart + place cards. (Yes, even Uncle Bob gets a seat.)",
    time_before: "2 weeks before"
  },
  {
    description: "Pack It Like a Pro",
    tip_from_collective: "Follow your Pack List and start putting things aside—you'll thank yourself later.",
    time_before: "2 weeks before"
  },
  {
    description: "Vows, But Make Them Yours",
    tip_from_collective: "Polish up those promises—sweet, funny, heartfelt, however you.",
    time_before: "2 weeks before"
  },

  // 7-14 Days Before
  {
    description: "Timing is Everything",
    tip_from_collective: "Confirm arrival and departure times so no one's guessing on the day.",
    time_before: "1 week before"
  },
  {
    description: "Showtime Script",
    tip_from_collective: "Share the final timeline + Run Of Show with your vendor crew.",
    time_before: "1 week before"
  },
  {
    description: "Bills, Bills, Bills (But Last Ones!)",
    tip_from_collective: "Make any outstanding payments—then close that tab forever.",
    time_before: "1 week before"
  },
  {
    description: "Outfits, Secured",
    tip_from_collective: "Pick up wedding attire, make sure it fits, and keep it safe from spills and wrinkles.",
    time_before: "1 week before"
  },
  {
    description: "Shine Bright Like a Diamond",
    tip_from_collective: "Give those rings a clean—they deserve their close-ups too.",
    time_before: "1 week before"
  },
  {
    description: "Vows, Take Two",
    tip_from_collective: "Practice your vows again. Out loud. (The mirror won't judge.)",
    time_before: "1 week before"
  },

  // 1-7 Days Before
  {
    description: "Pack, Then Double-Check",
    tip_from_collective: "Finish packing—including your Emergency Kit with all the day-of essentials.",
    time_before: "3 days before"
  },
  {
    description: "No Confusion, No Chaos",
    tip_from_collective: "Make sure the Wedding Party knows the who/what/where/when for every event.",
    time_before: "3 days before"
  },
  {
    description: "Weather Watch",
    tip_from_collective: "If you need heaters or tenting, now's the time to lock it in.",
    time_before: "3 days before"
  },
  {
    description: "Seats in Motion",
    tip_from_collective: "Make any last-minute guest seating changes (only if absolutely needed).",
    time_before: "3 days before"
  },
  {
    description: "In & Out",
    tip_from_collective: "Pick up and drop off any items where they need to go—no loose ends left behind.",
    time_before: "3 days before"
  },
  {
    description: "Rehearse ceremony at venue the Day Before",
    tip_from_collective: null,
    time_before: "1 day before"
  },

  // Your Wedding Day
  {
    description: "Take It All In",
    tip_from_collective: "Pause, breathe, and soak up every second—this is what all the planning was for.",
    time_before: null // El día de la boda
  },

  // Your First Married To-Do's
  {
    description: "Return all rentals",
    tip_from_collective: "Tables, chairs, glassware… don't let late fees steal your just-married glow.",
    time_before: null // Después de la boda
  },
  {
    description: "Create a shared photo album",
    tip_from_collective: "Guests love to play photographer. You'll be surprised by the gems you get.",
    time_before: null
  },
  {
    description: "Send quick thank-yous",
    tip_from_collective: "Vendors, helpers, that cousin who folded 100 napkins. A short note goes a long way.",
    time_before: null
  },
  {
    description: "Take off on your honeymoon",
    tip_from_collective: "(if that's the plan) — Or just honeymoon on the couch with pizza. Both count.",
    time_before: null
  }
]
